module.exports = __webpack_public_path__ + "img/move.d8bd13a0.svg";